import get from 'lodash/get';
import { node } from 'prop-types';
import React from 'react';

import { sessionShape } from '../../prop-types';
import withSessionInfo from '../with-session-info';
import RequireSignInOverlay from './RequireSignInOverlay';

function getUserIdFromSession(session) {
  return get(session, 'user.id', null);
}

class RequireSignIn extends React.Component {
  constructor(props) {
    super(props);

    this.wasActive = !!props.session;
    this.lastSeenUserId = getUserIdFromSession(props.session);
  }

  componentDidUpdate({ session: prevSession }) {
    const { session } = this.props;

    if (prevSession === null && session !== null) {
      this.wasActive = true;
    }

    const currentUserId = getUserIdFromSession(session);

    if (currentUserId === null) return;

    if (this.lastSeenUserId === null) {
      this.lastSeenUserId = currentUserId;
    }

    if (this.lastSeenUserId !== currentUserId) {
      window.location.reload();
    }
  }

  render() {
    const { children, session } = this.props;
    const { wasActive } = this;

    // On sign-in, the session is initialized without user information.
    // The user info is loaded in a separate request after, with a tiny delay.
    // Most nested components however rely on user information.
    const isActive = session && session.user;

    return (
      <>
        {(isActive || wasActive) && children}
        {!isActive && <RequireSignInOverlay />}
      </>
    );
  }
}

RequireSignIn.propTypes = {
  children: node,
  session: sessionShape,
};

RequireSignIn.defaultProps = {
  children: null,
  session: null,
};

export default withSessionInfo(RequireSignIn);
